import { Popover } from '@mui/material';
import { styled } from '@mui/material/styles';

const MobileChecklistTooltip = styled(Popover)({
    '& .MuiPopover-paper': {
        padding: '16px',
        backgroundColor: '#fff',
        borderRadius: '20px',
        border: '1px solid var(--black-20, rgba(17, 17, 17, 0.2))',
        boxShadow: '0px 12px 17px 2px rgba(0, 0, 0, 0.14)',
        fontFamily: "'Source Sans Pro'",
        filter: 'none',
        transform: 'none',
        width: '350px',
        maxHeight: '284px',
        bottom: '5px',
        position: 'relative',
        overflow: 'visible',
        '@media (max-width: 480px)': {
            left: '20px',
            bottom: '45px',
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            width: 24,
            height: 24,
            backgroundColor: 'white',
            transform: 'rotate(45deg)',
            zIndex: 1301,
            borderBottom: '1px solid  #CFCFCF',
            borderRight: '1px solid  #CFCFCF',
            top: '265px',
            left: '40vw',
        },
    },
});

export default MobileChecklistTooltip;
